import { render, staticRenderFns } from "./CalculatorResult.vue?vue&type=template&id=5be8571d&"
import script from "./CalculatorResult.vue?vue&type=script&lang=js&"
export * from "./CalculatorResult.vue?vue&type=script&lang=js&"
import style0 from "./CalculatorResult.vue?vue&type=style&index=0&id=5be8571d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QBtn,QIcon,QTooltip} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QBtn,QIcon,QTooltip})
